import React from "react";

interface SectionProps {
  id: string;
  children: React.ReactNode;
  height?: "full" | "large" | "medium" | "auto";
  className?: string;
}

const Section: React.FC<SectionProps> = ({
  id,
  children,
  height = "auto",
  className = "",
}) => {
  const heightClass =
    height === "full"
      ? "min-h-screen"
      : height === "large"
        ? "min-h-[80vh]"
        : height === "medium"
          ? "min-h-[60vh]"
          : "min-h-fit";

  return (
    <section
      id={id}
      className={`w-full flex flex-col justify-center items-center px-4 py-16 bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50 ${heightClass} ${className}`}
    >
      {children}
    </section>
  );
};

export default Section;
